import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function CardReviewedByOSCISC() {
  return (
    <Card className="tw:bg-transparent" size="sm">
      <CardHeader>
        <CardTitle>11. Reviewed by (OSC/ISC)</CardTitle>
      </CardHeader>
      <CardContent>
        <p>Awaiting signature</p>
      </CardContent>
    </Card>
  );
}
